<template>
  <div class="consumo">
    <div class="row">
      <public-header title="Gastos e Consumos">
        <div class="col-xs-12 col-sm-6">
          <p>
            Aqui você encontra informações sobre o consumo de recursos nas
            unidades municipais.
          </p>
          <p>
            Os indicadores de gastos têm o objetivo de monitorar o consumo de
            água e luz. Os dados de água são computados por m³, R$ e por
            PDE/RGI.
          </p>
          <p>
            No ano de <span class="destaque-header">{{ ano }}</span
            >, foi gasto com água um total de
            <span class="destaque-header">{{ valoresAgua }}</span> e com luz um
            total de <span class="destaque-header">{{ valoresLuz }}</span
            >.
          </p>
        </div>
      </public-header>
    </div>
    <div class="row">
      <div class="container">
        <breadcrumb :links="breadcrumb" />
        <div
          class="form-group"
          v-for="(item, index) in graficos"
          :key="'grafico-' + index"
        >
          <grafico-consumo
            :title="item.title"
            :reference="item.reference"
            :values="item.values"
            :keyValue="item.keyValue"
            :money="item.money"
            :unidades="item.unidades"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { PublicHeader, Breadcrumb, GraficoConsumo } from '../../../components'
import { request } from '../../../request'
import { formatarMoeda } from '../../../utils'

export default {
  components: {
    PublicHeader,
    Breadcrumb,
    GraficoConsumo
  },
  data() {
    return {
      ano: new Date().getFullYear(),
      breadcrumb: [
        {
          label: 'Gastos e Consumo'
        }
      ],
      listaAgua: [],
      secretariasAgua: [],
      listaEletricidade: [],
      secretariasEletricidade: []
    }
  },
  created() {
    this.getValoresTipoConta({
      url: 'consumo/agua',
      key: 'listaAgua',
      keySecretaria: 'secretariasAgua'
    })

    this.getValoresTipoConta({
      url: 'consumo/eletricidade',
      key: 'listaEletricidade',
      keySecretaria: 'secretariasEletricidade'
    })
  },
  methods: {
    async getValoresTipoConta(options) {
      const { url, key, keySecretaria } = options
      await this.requestGet({ url, key })
      this.getSecretarias({ key, keySecretaria })
    },
    async requestGet(options) {
      const { url, key, params } = options
      await request
        .get(url, { params: params })
        .then(response => {
          const { data } = response
          this[key] = data
        })
        .catch(error => {
          console.log(error.response)
        })
    },
    getSecretarias(options) {
      const { key, keySecretaria } = options
      const unique = [
        ...new Set(
          this[key]
            .filter(item => item.codigo_secretaria !== null)
            .map(item => item.codigo_secretaria)
        )
      ]

      this.requestGet({
        url: 'unidade-organizacional/secretarias',
        key: keySecretaria,
        params: { ids: unique }
      })
    },
    getValoresTotaisTipoConta(options) {
      const { key } = options
      const filter = item => parseInt(item.ano_ref) === this.ano
      const reducer = (anterior, { valor }) => {
        return anterior + parseFloat(valor)
      }

      const valor = this[key].filter(filter).reduce(reducer, 0)

      return formatarMoeda(valor)
    }
  },
  computed: {
    valoresAgua() {
      return this.getValoresTotaisTipoConta({ key: 'listaAgua' })
    },
    valoresLuz() {
      return this.getValoresTotaisTipoConta({ key: 'listaEletricidade' })
    },
    graficos() {
      return [
        {
          title: 'Total de água em R$ por mês',
          reference: 'grafico-agua-valor',
          values: this.listaAgua,
          keyValue: 'valor',
          money: true,
          unidades: this.secretariasAgua
        },
        {
          title: 'Total de água em m³ por mês',
          reference: 'grafico-agua-m3',
          values: this.listaAgua,
          keyValue: 'leitura_m3',
          money: false,
          unidades: this.secretariasAgua
        },
        {
          title: 'Total de eletricidade em R$ por mês',
          reference: 'grafico-eletricidade-valor',
          values: this.listaEletricidade,
          keyValue: 'valor',
          money: true,
          unidades: this.secretariasEletricidade
        },
        {
          title: 'Total de eletricidade em MW por mês',
          reference: 'grafico-eletricidade-mw',
          values: this.listaEletricidade,
          keyValue: 'leitura_mw',
          money: false,
          unidades: this.secretariasEletricidade
        }
      ]
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/public/consumo/index.vue